import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    menu:[],
    price:{},
  },
  actions: {
    init({commit}, e) {
      commit('SET', e);
    },
    initPrice({commit},e)
    {
      commit('SETPRICE',e);
    }
  },
  mutations: {
    /*config(state, data) {
          state.menus = data;
      },*/
      SET(state, data) {
        state.menu=data.menu;
      },
      SETPRICE(state,data){
        state.price=data;
      }
  }
}